import { Button } from "@/components/ui/button";
import { CHANNEL_DESC, CHANNEL_STATUS_DOT, channelStatusDisplay, channelCta } from "@/lib/connect";
import { WhatsappLogo, EnvelopeSimple, ChatText, PhoneCall } from "@phosphor-icons/react";

const META = {
  whatsapp: { label: "WhatsApp", Icon: WhatsappLogo, ring: "text-emerald-600" },
  email: { label: "Email", Icon: EnvelopeSimple, ring: "text-violet-600" },
  sms: { label: "SMS", Icon: ChatText, ring: "text-blue-600" },
  voice: { label: "Voice", Icon: PhoneCall, ring: "text-orange-600" },
};

// A single channel status card. Clean customer-facing copy; detailed setup requirements are
// revealed only after clicking the CTA (handled by the parent). No channel is simulated as active.
export function ChannelCard({ channel, status = "not_connected", onAction }) {
  const m = META[channel] || META.sms;
  const Icon = m.Icon;
  const { key, label } = channelStatusDisplay(channel, status);
  const dot = CHANNEL_STATUS_DOT[key] || CHANNEL_STATUS_DOT.not_connected;
  const comingSoon = channel === "voice";
  const cta = channelCta(channel, status);

  return (
    <div className="border border-border bg-card p-4 rounded-sm flex flex-col h-full" data-testid={`connect-channel-${channel}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2.5">
          <span className="h-9 w-9 rounded-sm bg-secondary flex items-center justify-center shrink-0">
            <Icon size={20} weight="bold" className={m.ring} />
          </span>
          <div className="font-heading font-bold">{m.label}</div>
        </div>
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-muted-foreground shrink-0" data-testid={`connect-channel-${channel}-status`}>
          <span className={`h-2 w-2 rounded-full ${dot}`} aria-hidden />
          {label}
        </span>
      </div>

      <p className="mt-3 text-xs text-muted-foreground leading-snug min-h-[2.5rem]">
        {CHANNEL_DESC[channel]}
      </p>

      <div className="mt-auto pt-3">
        <Button
          variant="outline"
          size="sm"
          disabled={comingSoon}
          onClick={() => onAction?.(channel, status)}
          className="rounded-sm w-full"
          data-testid={`connect-channel-${channel}-cta`}
        >
          {comingSoon ? "Coming Soon" : cta}
        </Button>
      </div>
    </div>
  );
}
